import React from 'react'
import { browserHistory } from 'react-router'

const Header = ({ links }) =>
  <header id="static-header">
    <div id="header-icons" className="nav-item">
      <div
        className="sub-nav-item"
        onClick={() => browserHistory.push('/dashboard')}
      >
        <i className="fa fa-home" aria-hidden="true" />
        <span className="sub-nav-text">خانه</span>
      </div>

      {links.map(link => {
        return (
          <div
            key={link.url}
            className="static-header-link"
            onClick={() => browserHistory.push(`/${link.url}`)}
          >
            {link.title}
          </div>
        )
      })}
    </div>
  </header>

const Footer = () =>
  <footer id="static-footer">
    <span>
      تمامی حقوق مادی و معنوی این سامانه متعلق به انتشارات فاطمی می باشد.
    </span>
  </footer>

const StaticPage = ({ page, headerItems }) =>
  <div className="static-content">
    <Header links={headerItems} />
    <div className="static-content--inner">
      <h4>
        {page.title}
      </h4>
      <hr />
      <div
        className="foreign-markup"
        dangerouslySetInnerHTML={{
          __html: page.content
        }}
      />
    </div>
    <Footer />
  </div>

export default StaticPage



// WEBPACK FOOTER //
// ./src/components/common/StaticPage.js